module.exports = __webpack_public_path__ + "static/media/back-mobile.378a9171.jpg";